/*
 * Sticky Header — Level 2 Alpine component
 *
 * Tracks whether the page has scrolled past a small threshold so the
 * desktop header can fade in its gradient backdrop only once the user
 * leaves the very top of the page.
 */
export default function stickyHeader() {
    return {
        scrolled: false,
        threshold: 8,
        _onScroll: null,

        init() {
            this._onScroll = () => {
                const next = window.scrollY > this.threshold;
                if (next !== this.scrolled) {
                    this.scrolled = next;
                }
            };
            this._onScroll();
            window.addEventListener('scroll', this._onScroll, { passive: true });
        },

        destroy() {
            if (this._onScroll) {
                window.removeEventListener('scroll', this._onScroll);
            }
        },

        get overlayClass() {
            return this.scrolled ? 'opacity-100' : 'opacity-0';
        },
    };
}
